

























































































import { defineComponent, ref, computed, Ref } from "@vue/composition-api";
import { useGetters, useActions } from "vuex-composition-helpers";
import useFetcher from "@use/useFetcher";
import LinkNotification from "@c/molecules/notification/LinkNotification.vue";
import Notification from "@c/molecules/notification/Notification.vue";
import NotificationModel from "@/ts/models/notificationClass";

export default defineComponent({
  name: "Notifications",

  components: {
    LinkNotification,
    Notification
  },

  setup() {
    const { newNotificationsCount } = useGetters({
      newNotificationsCount: "notification/newNotificationsCount"
    } as any);

    var showNotifications = ref(false);

    var { entity: notifications, loading: loading } = useFetcher(
      "notification/GET_NOTIFICATIONS", {action_param:{reload:true}, reload:300000}
    );

    const { REFRESH } = useActions({
      REFRESH: "notification/GET_NOTIFICATIONS"
    } as any);

    const refresh = () => {
      loading.value = true;
      REFRESH({ reload: true }).then((response: any) => {
        loading.value = false;
        notifications.value = response;
      });
    };

    var displayed_notifications: Ref<Array<NotificationModel>> = computed(
      () => {
        if (notifications.value) {
          return notifications.value.slice(0, 5);
        } else {
          return [];
        }
      }
    );

    var MoreNewNotifications: Ref<boolean> = computed(() => {
      if (notifications.value) {
        var MoreNews = notifications.value
          .slice(5)
          .filter((notification: NotificationModel) => !notification.read);
        return MoreNews.length ? true : false;
      } else {
        return false;
      }
    });

    return {
      showNotifications,
      newNotificationsCount,
      notifications,
      loading,
      refresh,
      displayed_notifications,
      MoreNewNotifications
    };
  }
});
